import { saveBlobAsFile } from 'shared/file/saveBlobAsFile'
import { extractFileNameFromContentPositionHeader } from '../../../../helpers/axios-header.helper'
import { getErrorMessage } from '../../../../helpers/errors.helper'
import { CreateOrUpdateTransitOperationRequestDeclarationTypeEnum } from '../../../../api/models'
import { DeclarationValidationRequestPhaseIdEnum } from '../../../../api/models/declaration-validation-request'
import { useDeclarationEditorContext } from '../../form/contexts/DeclarationEditorContext'
import useNctsPhase from '../../form/components/useNctsPhase'
import { fetchTSADPdf } from '../api/http'

function useDownloadTSADPdf() {
  const { phase } = useNctsPhase()
  const { editorData } = useDeclarationEditorContext()

  const downloadTSADPdf = async (transitOperationId: number): Promise<void> => {
    try {
      const isEns = editorData?.declarationType === CreateOrUpdateTransitOperationRequestDeclarationTypeEnum.ENS
      const phaseId = isEns || phase === 'p6'
        ? DeclarationValidationRequestPhaseIdEnum.P6
        : DeclarationValidationRequestPhaseIdEnum.P5
      const result = await fetchTSADPdf(transitOperationId, phaseId)

      const { data } = result
      const filename = extractFileNameFromContentPositionHeader(result)

      saveBlobAsFile(data, filename)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
      throw new Error(getErrorMessage(e) ?? 'Error occurred when fetching TSAD PDF')
    }
  }

  return {
    downloadTSADPdf,
  }
}

export default useDownloadTSADPdf
